<template>
  <div v-if="skills.length || isHaccpCertified" class="candidate-skills">
    <div class="candidate-skills-header">
      <p class="q-mb-none">{{ $t("ETAB.PAGES.EXTRA.@SKILLS_TITLE") }}</p>
    </div>
    <div class="candidate-skills-content">
      <div class="candidate-skills-items">
        <button v-if="isHaccpCertified" class="candidate-skills-item verfied">
          <img :src="extracadabraPicture" alt="HACCP" class="logo" />
          <span class="item-label">{{ $t("ETAB.PAGES.EXTRA.@HACCP_CERTIFIED") }}</span>
        </button>
        <button v-for="skill in skills" :key="skill.id" class="candidate-skills-item">
          {{ skill.name }}
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
  import { defineProps, ref } from "vue";

  const props = defineProps({
    skills: {
      type: Array,
      default: () => [],
    },
    isHaccpCertified: {
      type: Boolean,
      default: false,
    },
  });
  const logo = require("@etab/assets/img/extra_logo_white.png");

  const extracadabraPicture = ref(logo);
</script>

<style lang="scss" scoped>
  .candidate-skills {
    &-header {
      margin-left: 5px;
      margin-top: 20px;
      margin-bottom: 5px;

      > p {
        font-size: 22px;
        font-weight: 600;
        margin-bottom: 0px;
      }
    }

    &-content {
      position: relative;
      padding: 40px 20px;
      background-color: #fff;
      border-radius: 12px;
      box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
    }

    &-items {
      display: flex;
      flex-wrap: wrap;
      gap: 10px;
      justify-content: center;
    }

    &-item {
      background-color: $primary;
      color: white;
      border: none;
      border-radius: 16px;
      font-size: 16px;
      transition: all 0.3s ease;
      min-width: 100px;
      border-radius: 16px;
      padding: 3px 10px;
      &.verfied {
        background-color: $secondary;
        color: #ffeaee;
        display: flex;
        align-items: center;
        > .logo {
          width: 20px;
        }
        > .item-label {
          margin-left: 5px;
          font-weight: bold;
        }
      }
    }
  }
</style>
